import { Box, Chip, Tooltip, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import RepeatOverflowCounter from 'v2/components/RepeatOverflowCounter/RepeatOverflowCounter';

interface Item {
  id: string;
  name: string;
}

interface Props {
  items: Item[];
  emptyState?: React.ReactNode;
}

const ChipListCell: React.FC<Props> = ({ items, emptyState }) => {
  const theme = useTheme();

  const content =
    items.length === 0 ? (
      (emptyState ?? null)
    ) : (
      <RepeatOverflowCounter
        variant="chip"
        renderMore={(count) => {
          const tooltipTitle = items
            .slice(-count)
            .map((item) => item.name)
            .join(', ');
          return (
            <Tooltip title={tooltipTitle} placement="top">
              <Chip
                size="small"
                variant="filled"
                label={<Typography variant="caption">{`+${count}`}</Typography>}
                sx={{ backgroundColor: theme.custom.action.selected }}
              />
            </Tooltip>
          );
        }}
      >
        {items.map((item) => (
          <Chip
            key={item.id}
            size="small"
            variant="filled"
            label={<Typography variant="caption">{item.name}</Typography>}
            sx={{ backgroundColor: theme.custom.action.selected }}
          />
        ))}
      </RepeatOverflowCounter>
    );

  return (
    <Box height="52px" display="flex" alignItems="center">
      {content}
    </Box>
  );
};

export default ChipListCell;
